/**
 * Spreadsheet-style cell entry: click selects the whole value so typing
 * replaces leftover digits instead of appending after them.
 */

export function selectFieldText(e) {
  const el = e.currentTarget;
  try { el.select?.(); } catch { /* ignore */ }
  if (typeof requestAnimationFrame === 'function') {
    requestAnimationFrame(() => {
      try { el.select?.(); } catch { /* ignore */ }
    });
  }
}

/**
 * A click that focuses an input also places the caret, which undoes select-all.
 * Prevent that so existing characters are gone on the first keystroke.
 */
export function preserveFieldSelection(e) {
  e.preventDefault();
}
